import React from 'react';

import Cadastros from '@pages/Private/shared/ListPessoas';
import EditCadastro from '@pages/Private/shared/EditCadastro';
import NovoCadastro from '@src/Pages/Private/Cliente/shared/NovoCadastro';

import EditarUsuario from '@pages/Private/shared/EditarUsuario';
import ListaLigacao from '@pages/Private/Cliente/Operacional/ListaLigacao';
import WebPhoneAtivo from '@src/Pages/Private/Cliente/Operacional/WebPhoneAtivo';
import DoacoesMeta from '@pages/Private/Cliente/Operacional/DoacoesMeta';
import DoacoesMetaIR from '@pages/Private/Cliente/Operacional/DoacoesMetaIR';
import InserirDoacoes from '@src/Pages/Private/Cliente/Admin/InsercaoDoacoes';



import { ContactPage } from '@assets/Icons';
import { PhoneInTalk, FavoriteBorderOutlined, BarChart, LoyaltyOutlined  } from '@material-ui/icons';
import ListCorrespondenciaDevolvida from '@src/Pages/Private/Cliente/Operacional/CorrespondenciaDevolvida';
import { ForwardToInbox, mdiDatabaseSearch, Article } from '@assets/Icons/';
import DashboardCadastros from '@pages/Private/Cliente/Operacional/Dashboard'

import TriagemCadastro from '@pages/Private/shared/Triagem/ListPessoas';
import EditCadastroTriagem from '@pages/Private/shared/Triagem/EditCadastro';

import WebPhoneReceptivo from '@src/Pages/Private/Cliente/Operacional/WebPhoneReceptivo';

export interface IRoute {
  index: number | null;
  path: string;
  component: React.ComponentType<any>;
  roles: string[];
}

export interface IRouteMenu {
  index: number;
  path?: string;
  Icon?: React.ReactNode;
  label: string;
  roles: string[];
  menu: 'lateral' | 'header';
  subMenu?: IRouteMenu[];
}

export const routesOperacional: IRoute[] = [
  {
    index: 1,
    path: '/home',
    component: DoacoesMeta,
    roles: ['OPERACIONAL CLIENTE I'],
  },
  {
    index: 2,
    path: '/doacoesIR',
    component: DoacoesMetaIR,
    roles: ['OPERACIONAL CLIENTE I'],
  },
  {
    index: 1,
    path: '/dashboard',
    component: DashboardCadastros,
    roles: ['OPERACIONAL CLIENTE I'],
  },

  {
    index: 2,
    path: '/cadastros/',
    component: Cadastros,
    roles: ['OPERACIONAL CLIENTE I'],
  },
  {
    index: 3,
    path: '/cadastros/novo',
    component: NovoCadastro,
    roles: ['OPERACIONAL CLIENTE I'],
  },
  {
    path: '/cadastro/:idCadastro',
    component: EditCadastro,
    roles: ['OPERACIONAL CLIENTE I'],
    index: null,
  },
  {
    path: '/ligacoes',
    component: ListaLigacao,
    roles: ['OPERACIONAL CLIENTE I'],
    index: 5,
  },
  {
    index: 4,
    path: '/correspondencia',
    component: ListCorrespondenciaDevolvida,
    roles: ['OPERACIONAL CLIENTE I'],
  },
  {
    index: null,
    path: '/usuario/editar',
    component: EditarUsuario,
    roles: ['OPERACIONAL CLIENTE I'],
  },
  {
    index: null,
    path: '/inserir/doacoes',
    component: InserirDoacoes,
    roles: ['OPERACIONAL CLIENTE I'],
  },
  // {
  //   index: null,
  //   path: '/webphone/ativo',
  //   component: WebPhoneAtivo,
  //   roles: ['OPERACIONAL CLIENTE I'],
  // },
  {
    index: null,
    path: '/cadastros/triagem',
    component: TriagemCadastro,
    roles: ['OPERACIONAL CLIENTE I'],
  },
  {
    path: '/cadastro/triagem/:idCadastro',
    component: EditCadastroTriagem,
    roles: ['OPERACIONAL CLIENTE I'],
    index: null,
  },

];

export const routesOperacionalMenu: IRouteMenu[] = [
  {
    index: 1,
    path: '/home',
    label: 'Dulcete',
    Icon: <FavoriteBorderOutlined />,
    roles: ['OPERACIONAL CLIENTE I'],
    menu: 'header',
  },
  {
    index: 2,
    path: '/doacoesIR',
    label: 'Doações IR',
    Icon: ContactPage,
    roles: ['OPERACIONAL CLIENTE I'],
    menu: 'header',
  },
  {
    index: 2,
    label: 'Cadastros',
    path: '/cadastros',
    Icon: ContactPage,
    roles: ['OPERACIONAL CLIENTE I'],
    menu: 'lateral',
    subMenu: [
      {
        index: 2.2,
        path: '/cadastros',
        label: 'Gerenciar',
        roles: ['OPERACIONAL CLIENTE I'],
        menu: 'lateral',
      },
      {
        index: 2.2,
        path: '/cadastros/novo',
        label: 'Novo',
        roles: ['OPERACIONAL CLIENTE I'],
        menu: 'lateral',
      },
    ],
  },
  {
    index: 3,
    label: 'Correspondência devolvida',
    path: '/correspondencia',
    Icon: Article,
    roles: ['OPERACIONAL CLIENTE I'],
    menu: 'lateral',
  },
  {
    index: 4,
    label: 'Ligações',
    path: '/ligacoes',
    Icon: PhoneInTalk,
    roles: ['OPERACIONAL CLIENTE I'],
    menu: 'lateral',
  },
  {
    index: 5,
    label: 'Dashboard',
    path: '/dashboard',
    Icon: <BarChart />,
    roles: ['OPERACIONAL CLIENTE I'],
    menu: 'header',
  },
  {
    index: 6,
    label: 'Inserção de doações',
    path: '/inserir/doacoes',
    Icon: <LoyaltyOutlined />,
    roles: ['OPERACIONAL CLIENTE I'],
    menu: 'header',
  },
  {
    index: 7,
    path: '/cadastros/triagem',
    label: 'Triagem',
    roles: ['OPERACIONAL CLIENTE I'],
    menu: 'header',
  },

];
